import { UserPrefill } from './UserPrefill';

export class CompanyInvitation {
    CompanyId: number;
    InvitedEmail: string;
    ExpirationDate: Date;
    DoesUserExists?: boolean;
    CompanyName?: string;
    /**
     * Profile prepared by the administrator, applied when the invitation is
     * accepted. Fully filled on the company employees list, restricted to the
     * first and last names on the anonymous acceptance endpoint.
     */
    Prefill?: UserPrefill;

    constructor(model?: CompanyInvitation) {
        if (model) {
            this.CompanyId = model.CompanyId;
            this.InvitedEmail = model.InvitedEmail;
            this.ExpirationDate = new Date(model.ExpirationDate);
            this.DoesUserExists = model.DoesUserExists;
            this.CompanyName = model.CompanyName;
            this.Prefill = model.Prefill
                ? new UserPrefill(model.Prefill)
                : null;
        } else {
            this.CompanyId = null;
            this.InvitedEmail = null;
            this.ExpirationDate = new Date();
            this.DoesUserExists = null;
            this.CompanyName = null;
            this.Prefill = null;
        }
    }
}
